export const VIEW_REWARDS_URL = '/account/rewards';
